@if (open()) {
<div class="fixed inset-0 z-40 bg-black/60 backdrop-blur-sm" (click)="onClose()"></div>
<div class="fixed inset-0 z-50 flex items-center justify-center p-4" (click)="onClose()">
    <div class="bg-white rounded-2xl shadow-2xl w-full max-w-2xl flex flex-col overflow-hidden"
        (click)="$event.stopPropagation()">
        <div class="flex justify-between border-b">
            <h1 class="p-3 fw-600">{{ 'CUSTMSTR0021' | translate }}</h1>
            <button class="p-3 fw-600" (click)="onClose()"><i class="pi pi-times"></i></button>
        </div>
        <div class="w-full p-6 flex flex-col gap-3">
            <div class="grid grid-cols-1 gap-2">
                <div class="flex gap-2">
                    <div class="flex items-center">
                        <span class="text-ellipsis w-48">{{'CUSTMSTR0029' | translate}}</span>
                    </div>
                    <input type="text" pInputText readonly [value]="data()?.membeR_NO.slice(-13)" class="w-full">
                </div>
                <div class="flex gap-2">
                    <div class="flex items-center">
                        <span class="text-ellipsis w-48">{{'CUSTMSTR0017' | translate}}</span>
                    </div>
                    <input type="text" pInputText readonly [value]="data()?.membeR_NM" class="w-full">
                </div>
                <div class="flex gap-2">
                    <div class="flex items-center">
                        <span class="text-ellipsis w-48">{{'CUSTMSTR0031' | translate}}</span>
                    </div>
                    <input type="text" pInputText readonly [value]="data()?.hP_NO | phoneFormat" class="w-full">
                </div>
                <div class="flex gap-2">
                    <div class="flex items-center">
                        <span class="text-ellipsis w-48">{{'CUSTMSTR0019' | translate}}</span>
                    </div>
                    <input type="text" pInputText readonly [value]="(data()?.smS_YN === 'Y' ? 'CUSTMSTR0064' : 'CUSTMSTR0065') | translate" class="w-full">
                </div>
                <div class="flex gap-2">
                    <div class="flex items-center">
                        <span class="text-ellipsis w-48">{{'REVERSTR0061' | translate}}</span>
                    </div>
                    <input type="text" pInputText readonly [value]="data()?.avaiL_POINT | number" class="w-full">
                </div>
            </div>
            <!-- <div class="mt-8 flex justify-end">
                <button (click)="onClose()"
                    class="px-6 py-3 bg-gray-100 text-gray-700 font-bold rounded-lg hover:bg-gray-200 transition-colors">
                    {{ 'Close' | translate }}
                </button>
            </div> -->
        </div>

    </div>
</div>
}